function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import buttonConfig from "segments/desktop/core-components/button/signup-button/fields-config.js";
import ButtonFieldsConfig from "segments/desktop/core-components/button/fields-config";
import { SIGNUP_BUTTON_TYPE, CONTACT_SALES_BUTTON_TYPE, SIGNUP_COMBO_BUTTONS_TYPE, SIGNUP_AND_YOUTUBE_COMBO_BUTTONS_TYPE, GET_STARTED_CONTACT_SALES_COMBO_TYPE } from "segments/desktop/core-components/button/button-consts";
const { signupClusterId } = buttonConfig, restSignupButtonConfig = _object_without_properties(buttonConfig, [
    "signupClusterId"
]);
const allowedButtonTypes = [
    SIGNUP_BUTTON_TYPE,
    CONTACT_SALES_BUTTON_TYPE,
    SIGNUP_COMBO_BUTTONS_TYPE,
    SIGNUP_AND_YOUTUBE_COMBO_BUTTONS_TYPE,
    GET_STARTED_CONTACT_SALES_COMBO_TYPE
];
const filteredButtonConfig = _object_spread_props(_object_spread({}, ButtonFieldsConfig), {
    options: ButtonFieldsConfig.options.filter((option)=>allowedButtonTypes.includes(option.text))
});
export default {
    theme: {
        type: FIELD_TYPES.COLOR_PICKER,
        label: "Theme"
    },
    clusters: {
        type: FIELD_TYPES.MULTIPLE_NESTED,
        label: "Clusters",
        maxLimit: 9,
        nestedConfig: {
            type: FIELD_TYPES.NESTED,
            fields: {
                text: {
                    type: FIELD_TYPES.TEXT,
                    label: "Text",
                    translatable: true
                },
                image: {
                    type: FIELD_TYPES.GALLERY,
                    label: "Image"
                },
                colorName: {
                    type: FIELD_TYPES.COLOR_PICKER,
                    label: "Color"
                },
                clusterId: {
                    type: FIELD_TYPES.CLUSTERS,
                    label: "Cluster Id"
                },
                useCaseId: {
                    type: FIELD_TYPES.SUB_CLUSTERS,
                    label: "Usecase Id"
                },
                initiallySelected: {
                    type: FIELD_TYPES.BOOLEAN,
                    label: "Initially selected"
                }
            }
        }
    },
    buttonConfig: filteredButtonConfig
};
